import {Button} from '@dropbox/dig-components/buttons';
import {LayerContext} from '@dropbox/dig-components/layer';
import {UIIcon} from '@dropbox/dig-icons';
import {logAiSearchInteraction} from 'analytics/aiSearchAnalytics';
import {aiDrawerViewAtom} from 'atoms/aiSearch';
import {CompanyAskGlyph} from 'components/DSYS/CompanyOSLogo';
import {t} from 'i18next';
import {useAtom} from 'jotai';

const AI_SEARCH_NAV_CHIP_TOOLTIP_Z_INDEX = 20;

/**
 * When AI search is open but minimized, shows a compact control in the global header
 * (next to search) instead of a floating chip over page content.
 */
export const AiSearchMinimizedNavChip = () => {
  const [view, setView] = useAtom(aiDrawerViewAtom);

  const expandDrawer = () => {
    logAiSearchInteraction({action: 'nav_chip_click'});
    logAiSearchInteraction({action: 'drawer_open', source: 'nav_chip'});
    setView('expanded');
  };

  return (
    <LayerContext.Provider value={{zIndex: AI_SEARCH_NAV_CHIP_TOOLTIP_Z_INDEX}}>
      <Button
        variant={view === 'expanded' ? 'opacity' : 'outline'}
        disabled={view === 'expanded'}
        onClick={expandDrawer}
        aria-label={t('ai_search_ask')}
        withIconStart={<UIIcon src={CompanyAskGlyph} size="small" />}
      >
        {t('ai_search_chat_label')}
      </Button>
    </LayerContext.Provider>
  );
};
